<template>
  <div>
    <el-card>
      <div class="menu-box">
        <h2>服务类型管理</h2>
        <div class="box-bd">
          <!-- 头 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-button type="primary" @click="pAdd()">添加服务类型</el-button>
              <el-button type="warning" @click="dialogLog.state = true"
                >查看日志</el-button
              >
            </el-col>
          </el-row>
          <!-- 表格 -->
          <el-table
            v-loading="tableLoading"
            class="task-table"
            :data="tableData"
          >
            <el-table-column prop="name" label="服务类型名称">
            </el-table-column>
            <el-table-column prop="is_split" label="是否可拆分">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.is_split === 1">
                  是
                </el-tag>
                <el-tag type="warning" v-if="scope.row.is_split === 0">
                  否
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.status === 1">
                  启用
                </el-tag>
                <el-tag type="warning" v-if="scope.row.status === 0">
                  禁用
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column width="180" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="warning"
                  icon="el-icon-edit"
                  @click="handleEdit(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="remove(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :pager-count="15"
            @current-change="pageChange"
            @size-change="sizeChange"
            :page-sizes="[30, 60, 100]"
            layout="total, sizes, prev, pager, next"
            :page-size="this.query.limit"
            background
            :total="exp.total"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
    <!-- 添加/删除对话框 -->
    <el-dialog
      v-dialogDrag
      :title="title"
      :visible.sync="dialogVisible"
      :before-close="formClose"
    >
      <el-form :rules="formRules" ref="formRef" :model="form">
        <el-form-item
          prop="name"
          label="服务类型名称"
          :label-width="formLabelWidth"
        >
          <el-input @change="handleChange" v-model="form.name"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="sort" label="排序" :label-width="formLabelWidth">
          <el-input @change="handleChange" v-model="form.sort"></el-input>
        </el-form-item> -->

        <el-form-item
          prop="is_split"
          label="是否可拆分"
          :label-width="formLabelWidth"
        >
          <el-radio @change="handleChange" v-model="form.is_split" :label="0"
            >否</el-radio
          >
          <el-radio @change="handleChange" v-model="form.is_split" :label="1"
            >是</el-radio
          >
        </el-form-item>
        <el-form-item
          v-show="choseVisible"
          prop="include"
          label="子级分类"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="form.include"
            multiple
            style="width: 100%"
            placeholder="请添加不可拆分的子级分类"
            clearable
            @change="handleChange"
          >
            <el-option
              v-for="item in noneSplotList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="sort"
          label="排序"
          v-if="addOrEdit === 2"
          :label-width="formLabelWidth"
        >
          <el-input @change="handleChange" v-model="form.sort"></el-input>
        </el-form-item>
        <el-form-item
          v-if="addOrEdit === 2"
          prop="status"
          label="状态"
          :label-width="formLabelWidth"
        >
          <el-switch
            @change="handleChange"
            v-model="form.status"
            :active-value="1"
            :inactive-value="0"
            active-color="#13ce66"
            inactive-color="#ff4949"
          />
        </el-form-item>
      </el-form>
      <!-- 功能栏 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAE()">取 消</el-button>
        <el-button type="primary" @click="confirmAE()">确 定</el-button>
      </div>
    </el-dialog>

    <all-log :dialogLog="dialogLog" />
  </div>
</template>

<script>
import {
  getServiceList,
  addServiceType,
  getInfo,
  editServiceType,
  delServiceType,
  noSplitTypeList,
} from '@/api/edu/servicetype.js'

export default {
  data() {
    return {
      dialogLog: {
        state: false,
      },
      isEdit: false,
      tableLoading: false,
      warningText: '',
      exp: {
        total: 0,
      },
      query: {
        page: 1,
        page_code: '',
        limit: 7,
      },
      dialogVisible: false,
      changeDialogVisible: false,
      formRules: {
        name: {
          required: true,
          message: '请输入服务类型方式名称',
          trigger: 'blur',
        },
      },
      title: '添加服务类型',
      addOrEdit: 1,
      formLabelWidth: '120px',

      optionProps: {
        value: 'id',
        label: 'name',
        children: 'son',
        disabled: 'state',
      },
      form: {
        name: '',
        include: [],
        is_split: 0,
      },
      tableData: [],
      noneSplotList: [],
    }
  },
  created() {
    this.getList()
  },
  watch: {
    'form.is_split': {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal)

        if (oldVal === 0 && newVal === 1) {
          if (this.addOrEdit === 2) {
            console.log('触发')
            var idx = this.noneSplotList.findIndex((item) => {
              return item.id === this.form.id
            })
            if (idx) {
              this.noneSplotList.splice(idx, 1)
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    choseVisible() {
      if (this.form.is_split === 0) {
        return false
      } else if (this.form.is_split === 1) {
        return true
      }
    },
  },
  methods: {
    async getType() {
      const { data: res } = await noSplitTypeList()
      this.noneSplotList = res.data
    },
    pageChange(val) {
      this.query.page = val
      this.getList()
    },
    sizeChange(val) {
      this.query.limit = val
      this.getList()
    },
    async getList() {
      this.tableLoading = true
      const { data: res } = await getServiceList(this.query)
      console.log(res)
      if (res.code === 1) {
        this.tableData = res.data
        this.exp.total = res.exp.num
      } else {
        this.$message.error('获取数据失败！')
      }
      this.tableLoading = false
    },
    // 添加/编辑商品对话框关闭事件
    formClose() {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.cancelAE()
          // this.getDepartmentList()
          done()
        })
        .catch((_) => {})
    },
    handleChange() {
      console.log('change')
      this.isEdit = true
    },
    handleChangeClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.changeDialogVisible = false
          this.getList()
          done()
        })
        .catch((_) => {})
    },
    // 取消
    cancelAE() {
      this.title = '添加服务类型'
      this.addOrEdit = 1
      this.isEdit = false
      this.form = {
        name: '',
        include: [],
        is_split: 0,
      }
      setTimeout(() => {
        this.$refs.formRef.clearValidate()
      }, 30)
      this.dialogVisible = false
    },

    // 新增打开
    pAdd(row) {
      console.log(row)
      this.getType()
      this.dialogVisible = true
    },
    // 编辑打开
    async handleEdit(row) {
      this.dialogVisible = true
      this.getType()
      this.title = '编辑服务类型'
      this.addOrEdit = 2
      const { data: res } = await getInfo({
        id: row.id,
      })

      this.form = res.data

      this.form.id = row.id
      if (res.data.include && res.data.include.length !== 0) {
        let arr = res.data.include.split(',')
        console.log(arr)
        for (let i = 0; i < arr.length; i++) {
          arr[i] = Number(arr[i])
        }
        this.form.include = arr
      }
    },
    // 删除
    remove(row) {
      this.$confirm('确认删除？')
        .then(async (_) => {
          const { data: res } = await delServiceType({
            id: row.id,
          })
          if (res.code === 1) {
            this.$message.success('删除成功！')
            this.getList()
          } else {
            this.$message.error(res.message)
          }
          this.cancelAE()
          // this.getDepartmentList()
          done()
        })
        .catch((_) => {})
    },
    confirmAE() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          if (this.addOrEdit === 1) {
            // 添加
            const { data: res } = await addServiceType(this.form)
            if (res.code === 1) {
              this.$message.success('添加成功')
              this.getList()
              this.cancelAE()
            } else {
              this.$message.error(res.message)
            }
          } else {
            // 编辑

            if (this.isEdit === true) {
              if (this.form.is_split === 0) {
                delete this.form.include
              }
              const { data: res } = await editServiceType(this.form)
              if (res.code === 1) {
                this.$message.success('编辑成功')
                this.cancelAE()
                this.getList()
              } else {
                this.$message.error(res.message)
              }
            } else {
              this.$message.info('没有修改任何数据')
            }
          }
        }
      })
    },
  },
}
</script>

<style scoped>
.content {
  display: flex;
  align-items: center;
}
.content .warning-icon {
  width: 44px;
  height: 32px;
  margin-right: 10px;
  background: url('../../../assets/exclamationmark.png') no-repeat;
}
</style>
